import React, { useEffect, useRef } from "react"

import {
  addFirstReviewAnalyticsEvent,
  addWriteReviewAnalyticsEvent,
} from "@/components/Review/v1/analytics"

const ReviewDetail = props => {
  const { productInfo = {}, bazaarVoiceProductId = "" } = props
  const reviewContainer = useRef(null)
  useEffect(() => {
    // we need to use javascript to fetch dom element as it's a third party script getting loaded(BazaarVoice) here and we don't have control over dom.
    if (
      (!window.isFirstReviewEventLoaded || !window.isWriteReviewEventLoaded) &&
      bazaarVoiceProductId &&
      productInfo &&
      reviewContainer.current
    ) {
      addFirstReviewAnalyticsEvent(productInfo)
      addWriteReviewAnalyticsEvent(productInfo)
    }
    return () => {
      delete window.isFirstReviewEventLoaded
      delete window.isWriteReviewEventLoaded
      delete window.reiterate1
      delete window.reiterate
      delete window.checker
      delete window.modalCloseEventLoaded
    }
  }, [productInfo])

  return (
    <div className="review">
      <div className="kf-react-plp-container">
        <div className="ml-0 mr-0">
          <div className="review-container" id="product-review">
            <div
              data-bv-show="reviews"
              data-bv-product-id={bazaarVoiceProductId}
              ref={reviewContainer}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}

ReviewDetail.defaultProps = {
  bazaarVoiceProductId: "",
  productInfo: {},
}

export default ReviewDetail
